"use strict";
// Clearance method
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClearanceMethodByKey = exports.clearance_method_list = exports.clearance_methods = void 0;
const util_1 = require("./util");
exports.clearance_methods = [
    { key: 'clearance_harvest', tupuake_id: 4, display_name: 'Clearance/Harvest' },
    { key: 'adverse_event', tupuake_id: undefined, display_name: 'Adverse Event' },
];
exports.clearance_method_list = exports.clearance_methods.map((sp) => sp.key);
exports.getClearanceMethodByKey = (0, util_1.createFindByKeyUsingArray)(exports.clearance_methods, 'clearance_method');
